import { CanActivateFn, ActivatedRouteSnapshot } from '@angular/router';
import { LoginService } from '../pages/login/login.service';
import { inject } from '@angular/core';
import { Observable } from 'rxjs';
import { NzMessageService } from 'ng-zorro-antd/message';
import { PERMISSION_ERROR } from '../common/constants/app.constant';

export const roleGuard: CanActivateFn = (route: ActivatedRouteSnapshot): boolean | Observable<boolean> | Promise<boolean> => {
    const loginService = inject(LoginService);
    const nzMessageServive = inject(NzMessageService);
    const userRole: string = loginService.getUserRole();

    const errorMsg = PERMISSION_ERROR;
    const requiredRoles = route.data['roles'] as string[];

    if (!requiredRoles || requiredRoles.includes(userRole)) {
        return true;
    }
    nzMessageServive.error(errorMsg, {
        nzDuration: 5000
    });
    return false;
};
